module.exports = __webpack_public_path__ + "img/sort-table-col.747bdcd5.svg";